import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-success-card',
  templateUrl: './success-card.component.html',
})
export class SuccessCardComponent implements OnInit {

  @Input() message: string;

  constructor() { }

  ngOnInit() {}

}
